<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.de_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{
              customLabel.createTime || "单据日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.createTime
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_name">
            <label class="weui-form-preview__label">{{
              customLabel.de_name || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_custname">
            <label class="weui-form-preview__label">{{
              customLabel.de_custname || "需求来源"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_product_type">
            <label class="weui-form-preview__label">{{
              customLabel.de_product_type || "产品类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_product_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pj_code">
            <label class="weui-form-preview__label">{{
              customLabel.pj_code || "立项单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.pj_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_annual_sales_plan">
            <label class="weui-form-preview__label">{{
              customLabel.de_annual_sales_plan || "年销售计划"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_annual_sales_plan
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_sales_area">
            <label class="weui-form-preview__label">{{
              customLabel.de_sales_area || "销售目标区域"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_sales_area
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_sales_group">
            <label class="weui-form-preview__label">{{
              customLabel.de_sales_group || "销售目标群体"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_sales_group
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_emname">
            <label class="weui-form-preview__label">{{
              customLabel.de_emname || "需求人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_dpname">
            <label class="weui-form-preview__label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_dpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_describe">
            <label class="weui-form-preview__label">{{
              customLabel.de_describe || "需求描述"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_describe
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.dd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="dd_name">
              <label class="weui-form-preview__label">{{
                customLabel.dd_name || "名称"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_name }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_spec">
              <label class="weui-form-preview__label">{{
                customLabel.dd_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_spec }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_brand">
              <label class="weui-form-preview__label">{{
                customLabel.dd_brand || "品牌"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_brand }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_colour">
              <label class="weui-form-preview__label">{{
                customLabel.dd_colour || "颜色"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_colour }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_size">
              <label class="weui-form-preview__label">{{
                customLabel.dd_size || "尺寸"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_size }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_texture">
              <label class="weui-form-preview__label">{{
                customLabel.dd_texture || "材质"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_texture
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_silkscreen">
              <label class="weui-form-preview__label">{{
                customLabel.dd_silkscreen || "丝印"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_silkscreen
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_standard">
              <label class="weui-form-preview__label">{{
                customLabel.dd_standard || "标准"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.dd_standard
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="dd_remark">
              <label class="weui-form-preview__label">{{
                customLabel.dd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.dd_remark }}</span>
            </div>

            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text1 || '自定义字段1'"
              v-model="form.main.dd_text1"
              slot="dd_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text2 || '自定义字段2'"
              v-model="form.main.dd_text2"
              slot="dd_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text3 || '自定义字段3'"
              v-model="form.main.dd_text3"
              slot="dd_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text4 || '自定义字段4'"
              v-model="form.main.dd_text4"
              slot="dd_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.dd_text5 || '自定义字段5'"
              v-model="form.main.dd_text5"
              slot="dd_text5"
              hidden="true"
            />
          </custom-layout>
        </div>
      </div>

      <file-list v-model="form.main.de_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/demand_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="turnin_project"
        >转立项</a
      >

      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CustomField,
  },
  data() {
    return {
      baseUrl: "/api/plm/demand",
      codeField: "de_code",
      statusField: "de_statuscode",
      caller: "Demand",
      xtype: "plm-demand-formpanel",
    };
  },
  methods: {
    turnin_project() {
      var me = this,
        main = me.form.main,
        id = main.id;

      if (id) {
        me.$ajax({
          url: "/api/plm/proj/turnPlmProj/" + id,
          method: "POST",
        }).then(function (res) {
          if (res.success) {
            me.$weui.toast("转立项成功!");
            me.$router.push({
              name: "ProjEdit",
              params: {
                id: res.data.id,
              },
            });
          } else {
            me.$router.push({
              name: "Error",
              params: res,
            });
          }
        });
      }
    },
  },
};
</script>